import { HStack, VStack, Text } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { LateralBar } from '../../../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import {
  DetailsSkeleton,
  DoubleTextSkeleton,
  TextSkeleton,
} from '../../../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { useGlobalProductContext } from '../../../../../contexts';

export const ListLoadingItemMobile: React.FC = () => {
  const { product } = useGlobalProductContext();

  const middleInfos1 = [
    { label: 'Aplic. Min.', value: <DoubleTextSkeleton w="45%" /> },
    { label: 'Vencimento', value: <DoubleTextSkeleton w="50%" /> },
  ];

  const middleInfos2 = [
    { label: 'Carência', value: <DoubleTextSkeleton w="52%" /> },
    { label: 'Liquidez', value: <TextSkeleton w="60%" /> },
  ];

  const middleInfos3 = [
    { label: 'Taxa', value: <TextSkeleton w="35%" /> },
    { label: 'Rent. até venc.', value: <TextSkeleton w="40%" /> },
  ];

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']}>
      <LateralBar
        backgroundColor={product.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding={Spacing['inset.sm']} space={Spacing['stack.xxxs']} w="full">
        <HStack justifyContent="space-between" alignItems="center">
          <TextSkeleton hasCaptions w="35%" />
          <DetailsSkeleton />
        </HStack>
        <HStack justifyContent="space-between">
          {middleInfos1.map(({ label, value }) => (
            <VStack space={Spacing['stack.quarck']} key={label} w="1/2">
              <Text color="neutral.black" variant="semibold">
                {label}
              </Text>
              {value}
            </VStack>
          ))}
        </HStack>
        <HStack justifyContent="space-between">
          {middleInfos2.map(({ label, value }) => (
            <VStack space={Spacing['stack.quarck']} key={label} w="1/2">
              <Text color="neutral.black" variant="semibold">
                {label}
              </Text>
              {value}
            </VStack>
          ))}
        </HStack>
        <HStack justifyContent="space-between">
          {middleInfos3.map(({ label, value }) => (
            <VStack space={Spacing['stack.quarck']} key={label} w="1/2">
              <Text color="neutral.black" variant="semibold">
                {label}
              </Text>
              {value}
            </VStack>
          ))}
        </HStack>
      </VStack>
    </TableContent>
  );
};
